







import { ApiGroupBuyingOrderGroupOrderInfoResponse } from '@/api'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  data: ApiGroupBuyingOrderGroupOrderInfoResponse
}>(
  {
    props: ['data'],
  },
  () => class {},
)
